import React from "react";
import PaymentRequiestPageSection from "../../Sections/PaymentRequiestSection/Content";
const PaymentRequiestPage = () => {
  return <PaymentRequiestPageSection />;
};

export default PaymentRequiestPage;
